// getUserProfileUrl.js
'use strict';
import { EMPTY_OBJECT } from '../resource/defaults.js';
/**
 * Create a SEO-friendly user profile URL
 * @param {Object} [params={}] - Parameters object
 * @param {string} [params.userId=''] - User ID
 * @param {string} [params.username=''] - Username for /u/:username URL
 * @param {string} [params.subPath=''] - Sub-path suffix (e.g. 'flix', 'livestream')
 * @returns {string} Relative URL path (e.g. '/u/alice', '/user/123')
 * @example
 * getUserProfileUrl({ userId: '123', username: 'alice' })
 * // => '/u/alice'
 * getUserProfileUrl({ userId: '123' })
 * // => '/user/123'
 * getUserProfileUrl({ userId: '123', username: 'alice', subPath: 'flix' })
 * // => '/u/alice/flix'
 */
const getUserProfileUrl = params => {
  const { userId = '', username = '', subPath = '' } = params || EMPTY_OBJECT;
  if (!userId && !username) return '';
  const base = username
    ? `/u/${encodeURIComponent(username)}`
    : `/user/${encodeURIComponent(userId)}`;
  return subPath ? `${base}/${subPath}` : base;
};

export default getUserProfileUrl;
